<ng-container>
  <ng-container>
    <button
      mat-icon-button
      data-automation-id="smt-action-button-reload-table"
      (click)="reloadTable()"
      [attr.aria-label]="'ALDEN.ACTIONS.RELOAD_TABLE' | translate"
      [attr.title]="'ALDEN.ACTIONS.RELOAD_TABLE' | translate"
    >
      <mat-icon>refresh</mat-icon>
    </button>
  </ng-container>
</ng-container>

<ng-template>
  <span>{{ 'ALDEN.ACTIONS.RELOAD_TABLE' | translate }}</span>
</ng-template>
